export default function (state) {
    if(!state&&state.list)return false;
    return !!state.list.filter(i=>{return i.load}).length;
}